(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("bRDW3", function(module, exports) {
const $8a339f473ec864ce$var$initPosts = ()=>{
    document.querySelectorAll(".i-post:not(.--initialized").forEach((post)=>{
        const tagsOpen = post.querySelector(".i-post__tags-expand");
        const tagsClose = post.querySelector(".i-post__tags-close");
        const tags = post.querySelector(".i-post__tags");
        const handleOpenTags = ()=>{
            tagsOpen?.classList.add("--hide");
            tags?.classList.add("--open");
        };
        const handleCloseTags = ()=>{
            tagsOpen?.classList.remove("--hide");
            tags?.classList.remove("--open");
        };
        tagsOpen?.addEventListener("click", handleOpenTags);
        tagsClose?.addEventListener("click", handleCloseTags);
        post.classList.add("--initialized");
    });
};
$8a339f473ec864ce$var$initPosts();
document.addEventListener("postsReinit", $8a339f473ec864ce$var$initPosts);

});

})();
//# sourceMappingURL=post-item.376919fd.js.map
